/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotTotalsByIde extends models.CopilotActivityBase {
    getFixupPrototypeFunction() { return CopilotTotalsByIde.fixupPrototype; }

    static newInstance(model: Partial<CopilotTotalsByIde>): CopilotTotalsByIde {
        let obj = Object.assign(new CopilotTotalsByIde(), model);
        CopilotTotalsByIde.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotTotalsByIde>): CopilotTotalsByIde {
        if (!model) return null;
        return CopilotTotalsByIde.newInstance(<CopilotTotalsByIde> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotTotalsByIde) {
        if (!obj) return;

        models.CopilotTotalsByIde.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotTotalsByIde): boolean {
        if (models.CopilotActivityBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CopilotTotalsByIde.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * IDE name (e.g. vscode)
     */
    ide: string;

}
